import type { EquipmentAccessorialType } from '@fv/models/equipment'

import CheckboxField from '@/components/inputs/CheckboxField'

import { ShipmentFormSection } from './ShipmentFormSection'

type Props = {
  disabled?: boolean
  value: EquipmentAccessorialType[]
  onChange: (type: EquipmentAccessorialType, checked: boolean) => void
}

const ltlAccessorials: Array<{
  key: EquipmentAccessorialType
  label: string
}> = [
  { key: 'protect-from-freezing', label: 'Protect from freezing' },
  { key: 'single-shipment', label: 'Single shipment' },
]

export const LtlAccessorialsFormSection = ({
  disabled,
  value,
  onChange,
}: Props) => (
  <ShipmentFormSection
    pillClassName="bg-white border-fv-gray !border-2"
    className="bg-fv-gray-100 border-fv-gray-500 flex items-center gap-x-4"
    title="Accessorials"
  >
    {ltlAccessorials.map(({ key, label }) => (
      <CheckboxField
        key={key}
        checked={value.includes(key)}
        disabled={disabled}
        label={label}
        name={key}
        onChange={e => onChange(key, e.target.checked)}
      />
    ))}
  </ShipmentFormSection>
)
